import type { GameProvider } from '../../../types';
import { formatCurrency } from '../../../utils';

const EMPTY = '—';

function parseAmount(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number.parseFloat(String(value));
  return Number.isFinite(n) ? n : null;
}

export function getMinDeposit(provider: GameProvider): number | null {
  return parseAmount(provider.minDeposit ?? provider.min_deposit);
}

export function getMaxDeposit(provider: GameProvider): number | null {
  return parseAmount(provider.maxDeposit ?? provider.max_deposit);
}

export function getProviderCurrency(provider: GameProvider): string {
  const code = String(provider.currency ?? '').trim();
  return code || 'USD';
}

export function formatDepositLimit(
  value: number | string | null | undefined,
  currency: string,
): string {
  const amount = parseAmount(value);
  if (amount === null) return EMPTY;
  return formatCurrency(amount, currency || 'USD');
}

export function formatProviderCurrency(provider: GameProvider): string {
  const code = String(provider.currency ?? '').trim();
  if (!code) return EMPTY;
  return code.toUpperCase();
}
